import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { FeedbackSubmitComponent } from 'src/@order/dialogs/feedback-submit/feedback-submit.component';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

interface Feedback {
  id: number;
  name: string;
  date: string;
  time: string;
  rating: number;
  selectedRating?: number;
  isSelected: boolean;
  delivered: boolean;
}

@Component({
  selector: 'app-pending-feedback-listing',
  templateUrl: './pending-feedback-listing.component.html',
  styleUrls: ['./pending-feedback-listing.component.scss']
})
export class PendingFeedbackListingComponent implements OnInit {
  feedbackList: Feedback[] = [];
  selectAll: boolean = false;
  lastSelectedRating: number = 0;

  constructor(private _auth: AuthServiceLocal, private _matDialog: MatDialog, private router: Router, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.getFeedbackData();
  }

  getFeedbackData() {
    this._auth.getPendingFeedbacks().subscribe((res: any) => {
      if (res.data.completedOrders)
        this.feedbackList = res.data.completedOrders;
      console.log("_auth", res.data.completedOrders);

      this.updateSelectAllState();
    });
  }

  toggleSelectAll(): void {
    this.selectAll = !this.selectAll;

    // Apply selection state to all items
    this.feedbackList.forEach(feedback => {
      feedback.isSelected = this.selectAll;
      
      // Apply the last selected rating to all selected items
      if (this.selectAll && this.lastSelectedRating > 0) {
        feedback.selectedRating = this.lastSelectedRating;
      }
    });
  }
  
  // Check if any feedback item has a star rating
  hasAnyRating(): boolean {
    return this.feedbackList.some(feedback => feedback.selectedRating && feedback.selectedRating > 0);
  }

  toggleFeedbackSelection(feedback: Feedback): void {
    feedback.isSelected = !feedback.isSelected;
    this.updateSelectAllState();
  }

  updateSelectAllState(): void {
    this.selectAll = this.feedbackList.length > 0 && this.feedbackList.every(feedback => feedback.isSelected);
  }

  setRating(feedback: Feedback, rating: number): void {
    feedback.selectedRating = rating;
    this.lastSelectedRating = rating;
    
    // If this item is not already selected, select it
    if (!feedback.isSelected) {
      feedback.isSelected = true;
      this.updateSelectAllState();
    }
  }

  submitFeedback(): void {
    const selectedFeedback: any = this.feedbackList.filter(feedback => feedback.isSelected);

    if (selectedFeedback?.length) {
      const orders = selectedFeedback?.map(item => {
        return {
          orderId: item?.id,
          ratedfor: item?.userIdDriver,
          ratedfortype: 6,
          rating: item?.selectedRating || 0
        }
      });

      const isAllRatingsSelected = orders.every(order => order.rating > 0);

      if (!isAllRatingsSelected) {
        this._snackBar.open('Each order must have a rating greater than 0', 'OKAY', { duration: 3000 });
        return;
      }

      const payload = {
        isIgnore: 0,
        orders: orders
      }

      this._auth.storeFeedBackRating(payload).subscribe((res: any) => {
        console.log("getPendingFeedbacks", res);
        if (res.response == 1) {
          const dialog = this._matDialog.open(FeedbackSubmitComponent, {
            panelClass: ['commonDialogWrapper'],
            backdropClass: 'dialogBackdrop',
            autoFocus: false,
            width: '510px',
            disableClose: true,
          }).afterClosed().subscribe(res => {
            this.router.navigate(['/'])
          });
        }
      });
    } else {
      this._snackBar.open('Please select at least one order to submit.', 'OKAY', { duration: 3000 });
    }
  }
}